<template>
    <!-- 实施结束 -->
    <van-popup
        v-if="workOrderFeedBackFinishPopupShow"
        :value="workOrderFeedBackFinishPopupShow"
        z-index="100"
        :close-on-click-overlay="false"
        :style="{ height: '100vh', width: '100vw', background: 'rgba(0,0,0,.3)' }"
        overlay-class="custom_popup"
        position="right"
    >
        <div class="public_container add_approval_wrap">
            <div class="returnNavBar">
                <ReturnNavBar
                    :isCustomReturnEvent="true"
                    :isTitleNormal="true"
                    :isAllFunctions="true"
                    title="返回"
                    @returnEvent="handleClickClose"
                ></ReturnNavBar>
            </div>
            <div class="work_order_add_container mobile_container custom_mobile_form" v-loading="loading">
                <van-form
                    label-width="9.5em"
                    input-align="right"
                    scroll-to-error
                    :show-error-message="false"
                    :rules="workOrderFeedBackFinishFormRules"
                    ref="workOrderFeedBackFinishForm"
                    class=""
                >
                    <van-field
                        :required="true"
                        v-model="workOrderFeedBackFinishForm.end_date_text"
                        :name="'end_date'"
                        label="实施结束时间"
                        placeholder="请选择"
                        :rules="workOrderFeedBackFinishFormRules.end_date"
                        error-message-align="right"
                        is-link
                        readonly
                        @click="handleClickDateFieldlink()"
                    >
                    </van-field>
                </van-form>
            </div>
            <div class="add_footer_wrap mobile_add_footer_wrap">
                <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm"
                    >确定</van-button
                >
            </div>
            <!--_年_月_日 日期选择-->
            <van-calendar
                v-model="showDateCalendar"
                color="#2990FF"
                :min-date="dateCalendarMin"
                :max-date="dateCalendarMax"
                @confirm="handleDateCalenderConfirm"
            />
            <van-overlay
                :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
                z-index="1000"
                v-if="handleRadioPicker"
                :show="handleRadioPicker"
                @click="handleRadioPicker = false"
            >
                <div class="custome_radio_option_wrap">
                    <ul class="radio_option_list">
                        <li
                            class="radio_option_item"
                            v-for="item in radioOptions"
                            :key="item.value"
                            @click="handleClickOption(item)"
                        >
                            {{ item.label }}
                        </li>
                        <div class="cancel_btn" @click="handleClickRadioCancel">取消</div>
                    </ul>
                </div>
            </van-overlay>
        </div>
    </van-popup>
</template>
<script>
import { formatDate } from "@/utils";
import { workOrderFeedbackEnd } from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
export default {
    name: "WorkOrderFeedBackFinish",
    components: { ReturnNavBar },
    props: {
        workOrderFeedBackFinishPopupShow: {
            type: Boolean,
            default: false,
        },
        workorder_id: "",
        workorder_num: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            loading: false,
            workOrderFeedBackFinishForm: {
                end_date: "",
                end_time: 1,
                end_date_text: "",
            },
            workOrderFeedBackFinishFormRules: {
                end_date: [{ required: true, message: "请选择时间", trigger: ["blur", "change"] }],
            },

            showDateCalendar: false,
            dateCalendarMin: new Date("2015-01-01"),
            dateCalendarMax: new Date("2070-01-01"),
            handleRadioPicker: false,
            radioOptions: [
                { label: "上午", value: 1 },
                { label: "下午", value: 2 },
            ],

            btnDisabled: false,
        };
    },
    created() {},
    methods: {
        handleClickClose() {
            this.$emit("update:workOrderFeedBackFinishPopupShow", false)
        },
        handleClickDateFieldlink() {
            this.showDateCalendar = true;
        },
        //点击日期选择器确定事件
        handleDateCalenderConfirm(date) {
            this.currentDate = date;
            this.showDateCalendar = false;
            this.handleRadioPicker = true;
        },
        // 选择时间段确认
        handleClickOption(item) {
            this.$set(this.workOrderFeedBackFinishForm, "end_date", formatDate(this.currentDate, "date"));
            this.$set(this.workOrderFeedBackFinishForm, "end_time", item.value);
            this.$set(
                this.workOrderFeedBackFinishForm,
                "end_date_text",
                formatDate(this.currentDate, "date") + "-" + item.label
            );
            this.handleRadioPicker = false;
        },
        // 选择取消
        handleClickRadioCancel() {
            this.currentDate = null;
            this.handleRadioPicker = false;
        },
        handleClickConfirm() {
            this.$refs.workOrderFeedBackFinishForm.validate().then(() => {
                const params = {
                    workorder_id: this.workorder_id,
                    workorder_num: this.workorder_num,
                    end_date: this.workOrderFeedBackFinishForm.end_date,
                    end_time: this.workOrderFeedBackFinishForm.end_time,
                };
                this.btnDisabled = true;
                workOrderFeedbackEnd(params)
                    .then((res) => {
                        if (res.code === 200) {
                            this.$toast({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.btnDisabled = false;
                                    this.$emit("update:workOrderFeedBackFinishPopupShow", false)
                                    this.$emit("feedBackFinishSuccess")
                                },
                            });
                        } else {
                            this.btnDisabled = false;
                        }
                    })
                    .catch(() => {
                        this.btnDisabled = false;
                    });
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.mobile_container {
    width: 100%;
    padding: 10px 0;
    box-sizing: border-box;
}
</style>
